import React from 'react';
import { usePortal } from '../contexts/PortalContext';
import { PROTOTYPE_MODE } from '../utils/env';

/**
 * Development-only switcher between the two interfaces. Hidden entirely in
 * production — it is never part of the real client experience.
 */
export function ViewToggle() {
  const {
    setViewMode,
    inStaffArea
  } = usePortal();
  if (!PROTOTYPE_MODE) return null;
  const onDark = inStaffArea;
  return <div className={['fixed bottom-5 right-5 z-40 flex items-center gap-3 border px-3 py-2 backdrop-blur-sm', onDark ? 'border-ruleDark bg-ink/80 text-paper' : 'border-rule bg-paper/85 text-ink'].join(' ')} data-id="element-452" data-mp="1g3nd3zuvhz60">
      <span className={['label-sm', onDark ? 'text-paper/40' : 'text-mute'].join(' ')} data-id="element-453" data-mp="1pyysmke3vaet">
        Prototype
      </span>
      <span className={onDark ? 'h-3 w-px bg-paper/20' : 'h-3 w-px bg-rule'} data-id="element-454" data-mp="xcdyxda5qm83" />
      <button type="button" onClick={() => setViewMode('client')} className={['label px-1 transition-opacity duration-150 ease-out', !inStaffArea ? 'opacity-100 underline underline-offset-4' : 'opacity-40 hover:opacity-80'].join(' ')} data-id="element-455" data-mp="xa9xd1zqdzaz">
        Client View
      </button>
      <button type="button" onClick={() => setViewMode('portal')} className={['label px-1 transition-opacity duration-150 ease-out', inStaffArea ? 'opacity-100 underline underline-offset-4' : 'opacity-40 hover:opacity-80'].join(' ')} data-id="element-456" data-mp="1j22twj1elrtl">
        Staff View
      </button>
    </div>;
}